import axios from 'axios';
const baseURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api/";
console.log("Base URL is:", baseURL);
const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const isRefreshingEndpoint = originalRequest.url.includes("token/refresh");

    if (error.response?.status === 401 && !isRefreshingEndpoint) {
      const refreshToken = localStorage.getItem('refresh_token');

      if (refreshToken) {
        try {
          const { data } = await axios.post(`${baseURL}accounts/token/refresh/`, {
            refresh: refreshToken,
          });

          const newAccessToken = data.access;
          localStorage.setItem('access_token', newAccessToken);

          // Update original request and retry it
          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return axiosInstance(originalRequest);

        } catch (refreshError) {
          console.error("Refresh failed, logging out...");
          localStorage.clear();
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      } else {
        console.warn("No refresh token, logging out...");
        localStorage.clear();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);


export default axiosInstance;
